import MetaTags from "react-meta-tags";
import React, { useState, useEffect } from "react"
import { Row, Col, CardBody, Card, Container } from "reactstrap";
/*import ImageViewer from "react-simple-image-viewer";*/
import PropTypes from 'prop-types';


const ShowPhoto = () => {

    const images = [
        "http://placeimg.com/1200/800/nature",
        "http://placeimg.com/800/1200/nature",
        "http://placeimg.com/1920/1080/nature",
        "http://placeimg.com/1500/500/nature"
    ];

    return (
        <></>
    );
};

ShowPhoto.propTypes = {
    srcPath: PropTypes.string
}

export default ShowPhoto


